import { createRouter, createWebHashHistory } from "vue-router";
import Video from "../views/Video.vue";
import jsCookie from "js-cookie";

const routes = [
  {
    path: "/",
    name: "Video",
    component: Video,
    meta: { requiresAuth: false },
  },
  {
    path: "/liveList",
    name: "liveList",
    component: () => import("../views/LiveList.vue"),
  },
  {
    path: "/wx_auth",
    name: "wx_auth",
    component: () => import("../views/WechatAuth.vue"),
    meta: {
      index: 1,
    },
  },
  {
    path: "/zsplus_auth",
    name: "zsplus_auth",
    component: () => import("../views/ZsplusAuth.vue"),
  },
  {
    path: "/empty",
    name: "empty",
    component: () => import("../views/EnvEmpty.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const userAgentString = navigator.userAgent.toLowerCase();
  if (userAgentString.indexOf("zsrbapp") >= 0) {
    console.log("into zsrbapp env");
    // 校验中山+存储的授权信息
    const zsplusInfo = sessionStorage.getItem("zsplusInfo");
    const token = jsCookie.get("token");

    let toPath = `${to.path}?${window.location.hash.split("?")[1]}`;

    if (!token && to.name !== "zsplus_auth") {
      sessionStorage.setItem("zsplusRedirectUrl", toPath);
      next({
        name: "zsplus_auth",
      });
    } else if (!zsplusInfo && to.name !== "zsplus_auth") {
      sessionStorage.setItem("zsplusRedirectUrl", toPath);
      next({
        name: "zsplus_auth",
      });
    } else {
      window.scrollTo(0, 0);
      next();
    }
  } else if (userAgentString.indexOf("micromessenger") >= 0) {
    // next();
    // 微信授权页路径（空白页）
    if (to.path === "/wx_auth") {
      console.log("into wxauth");
      next();
      return;
    }
    // 校验微信授权时存储的微信授权信息
    // const wxInfo = sessionStorage.getItem("wxInfo");
    const token = jsCookie.get("token");
    // 没有用户信息（即未进行微信授权）
    if (!token) {
      console.log("into getauth");
      // 存储默认打开时访问的页面路径
      // sessionStorage.setItem("wxRedirectUrl", to.path);
      // 处理URL地址栏所携带的参数
      let toPath = `${to.path}?${window.location.hash.split("?")[1]}`;
      // 微信授权获取用户信息指定的路径
      const redirect_uri = encodeURIComponent(
        `https://zsrbactivity.zsnews.cn/vue/slow_live/#/wx_auth?toPath=${toPath}`
      );
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2d1b0208e6e6741f&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    } else {
      //有了用户信息直接跳转
      window.scrollTo(0, 0);
      next();
    }
  } else {
    // if (to.name !== "empty")
    //   next({
    //     name: "empty",
    //   });
    // else {
      // window.scrollTo(0, 0);
      next();
    // }
  }
});

export default router;
